import { TitleBar } from '@shopify/app-bridge/actions';


function initializeShopifyApp() {
  const el = document.getElementById('shopify-app-init');
  if (!el) return;

  const data = el.dataset;
  const hostParam = new URLSearchParams(window.location.search).get('host');
  const host = hostParam || data.host;

  if (!host) {
    console.warn("Missing host param, redirecting to embedded version...");
    const redirectUrl = `/?host=${encodeURIComponent(data.host)}&shop=${encodeURIComponent(data.shopOrigin)}`;
    window.location.assign(redirectUrl);
    return;
  }

  const AppBridge = window['app-bridge'];
  if (!AppBridge) return;

  const createApp = AppBridge.default;
  const app = createApp({
    apiKey: data.apiKey,
    host: host,
    forceRedirect: true,
  });

  window.app = app; // make globally accessible

  // Title Bar
  TitleBar.create(app, { title: data.page || document.title });
}

// ✅ Run on both full page load and Turbo/Turbolinks navigation
document.addEventListener('turbolinks:load', initializeShopifyApp);
document.addEventListener('turbo:load', initializeShopifyApp);
